var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6536 0.431152C19.314 0.431152 24.7095 5.83953 24.7095 12.5C24.7095 19.1733 19.314 24.5689 12.6536 24.5689C5.98026 24.5689 0.584778 19.1733 0.584778 12.5C0.584778 5.83953 5.98026 0.431152 12.6536 0.431152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5482 10.3017C11.991 7.36721 15.5321 5.60901 17.6123 7.73873C17.6123 7.73873 18.5408 7.47865 19.3705 6.95869C19.3705 6.95869 19.0733 7.9616 18.058 8.59309C18.058 8.59309 19.1847 8.44444 19.6677 8.14725C19.6677 8.14725 19.1847 9.15026 18.2809 9.52167C18.7762 16.2697 11.508 20.3556 5.62677 17.0126C5.62677 17.0126 8.52405 17.1611 9.7623 15.7373C9.7623 15.7373 7.96688 15.8983 7.07541 13.7314C7.07541 13.7314 7.74402 13.9915 8.41262 13.6572C8.41262 13.6572 6.33248 13.3228 6.14683 10.8218C6.14683 10.8218 6.81543 11.3542 7.55836 11.1684C7.55836 11.1684 5.25536 9.78165 6.55535 7.29299C6.55535 7.29299 9.01937 10.4131 12.5482 10.3017Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTwitterIcon);
export default __webpack_public_path__ + "static/media/dark_twitter_icon.b5de17373e61c56cf9cfb67e4b649c08.svg";
export { ForwardRef as ReactComponent };